import React, { useState, useRef, useEffect } from "react";
import "./CwLogin.scss";
import logo from "../../assets/images/login/logo.svg";
import AdminAPI from "../../API/admin";
import MemberAPI from "../../API/member";
import Validator from "../../util/validator";
import config from "../../const/config";

const CwLogin = ({ history }) => {
  let idRef = useRef();
  let pwRef = useRef();

  const [error, setError] = useState(false);
  const loginType = 1; // 개인으로 고정

  const onClickLogin = () => {
    let id = idRef.current.value;
    let pw = pwRef.current.value;
    let refs = [idRef, pwRef];

    if (Validator.refValidator(refs)) {
      MemberAPI.login({ is_corporate: loginType, id: id, password: pw }).then(
        (res) => {
          const data = res.data;
          checkLogin(data, () => setError(true));
        }
      );
    }
  };

  const checkLogin = async (data, errorCallback) => {
    if (data.token) {
      sessionStorage.setItem(config.keyToken, data.token);

      const isAdmin = await AdminAPI.checkAuth({
        headers: { "x-token": data.token },
      }).then((res) => res.data);

      let historyURL = sessionStorage.getItem("historyURL");
      if (historyURL) {
        window.location.href = historyURL;
        sessionStorage.removeItem("historyURL");
        return;
      }

      if (window.$Global.checkAuth("대리인", data.rank)) {
        window.location.href = "/choice";
      } else if (isAdmin) {
        window.location.href = "/admin/check";
      } else if (window.$Global.checkAuth("특허회사_발명자만", data.rank)) {
        window.location.href = "/patent/list";
      } else {
        window.location.href = "/";
      }
    } else {
      errorCallback();
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    onClickLogin();
  };

  return (
    <div id="CwLogin">
      <div className="cwlogin-main">
        <div className="cwlogin-logo-section">
          <img src={logo} alt="국립창원대학교" className="cwlogin-logo" />
        </div>
        <div className="cwlogin-container">
          <div className="cwlogin-card">
            {/* 왼쪽 로그인 폼 */}
            <div className="cwlogin-form-section">
              <div className="cwlogin-form-area">
                <h2 className="cwlogin-title">특허관리시스템 LOGIN</h2>

                <form onSubmit={handleLogin} className="cwlogin-form">
                  <div className="cwlogin-input-group">
                    <input
                      type="text"
                      name="userId"
                      ref={idRef}
                      placeholder="아이디"
                      className="cwlogin-input"
                      data-name="아이디"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") onClickLogin();
                      }}
                      defaultValue={"univ_changwon_"}
                    />
                  </div>

                  <div className="cwlogin-input-group">
                    <input
                      type="password"
                      name="password"
                      ref={pwRef}
                      placeholder="비밀번호"
                      className="cwlogin-input"
                      data-name="비밀번호"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") onClickLogin();
                      }}
                    />
                  </div>

                  {error && (
                    <p className="cwlogin-error">
                      가입하지 않은 아이디이거나 잘못된 비밀번호입니다.
                    </p>
                  )}

                  <button type="submit" className="cwlogin-button">
                    로그인
                  </button>
                </form>

                <div className="cwlogin-contact-info">
                  ID/PW 문의 : 특허담당자(055-213-4176/4178)
                </div>
              </div>
            </div>

            {/* 오른쪽 배경 이미지 */}
            <div className="cwlogin-background-section">
              {/* 배경 이미지는 CSS에서 처리 */} 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CwLogin;
